export const LOCALES = ['en', 'hu'] as const

export type Locale = (typeof LOCALES)[number]

/** English is the default interface language; Hungarian is second. */
export const DEFAULT_LOCALE: Locale = 'en'

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value)
}

/**
 * Picks the requested locale from a contract localized map, falling back to
 * {@link DEFAULT_LOCALE} and then to any present entry rather than to a blank.
 */
export function resolveLocalized<T>(
  values: Readonly<Partial<Record<string, T>>>,
  locale: Locale,
): T | undefined {
  return values[locale] ?? values[DEFAULT_LOCALE] ?? Object.values(values).find((v) => v !== undefined)
}
